import { ArrowRightIcon, Button, PostcardIcon } from '@postidigital/posti-components'
import { BrandTheme } from '@postidigital/posti-theme'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { IInvite } from '../../store/dataModels/interfaces'
import { formatDate, getInviteState } from '../../utils'
import { useFeatureNavigation } from '../../utils/useFeatureNavigation'

interface IProps {
  invite: IInvite
}

export const InviteListItemComponent: React.FC<IProps> = ({ invite }) => {
  const { expired, email, expires, created, inviteId, cancelled, accepted } = invite
  const { t } = useTranslation()
  const { navigate } = useFeatureNavigation()

  const goToInvite = () => {
    navigate(`/invite-detail/${inviteId}`)
  }

  const getPostCardIconColor = (): string => {
    const pink = BrandTheme.color.surface.error.pressed
    const blue = BrandTheme.color.surface.success.pressed

    if (accepted) {
      return blue
    }

    if (cancelled) {
      return pink
    }

    if (expired) {
      return pink
    }

    return blue
  }

  return (
    <StyledTR onClick={goToInvite}>
      <StyledEmailText>
        <PostcardIcon color={getPostCardIconColor()} fontSize="14px" width={'24px'} height={'24px'} />
        <StyledSpan>{truncate(email, 30)}</StyledSpan>
      </StyledEmailText>
      <StyledCreatedText>{formatDate(created)}</StyledCreatedText>
      <StyledTimeExpired expired={expired}>
        {getInviteState(cancelled, expired, expires, accepted, t)}
      </StyledTimeExpired>

      <StyledArrowWrapper>
        <Button isOnlyIcon contentMode="tertiary" type="button" rightIcon={ArrowRightIcon} />
      </StyledArrowWrapper>
    </StyledTR>
  )
}

export const InviteListItem = observer(InviteListItemComponent)

const StyledTR = styled.tr(
  () => css`
    height: 48px;
    cursor: pointer;
  `
)

function truncate(str, n) {
  return str.length > n ? str.substr(0, n - 1) + '...' : str
}

const StyledSpan = styled.span(
  () => css`
    margin-left: 8px;
  `
)

const StyledEmailText = styled.td(
  ({ theme }) => css`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 143%;
    color: ${theme.color.text.title.primary};
    vertical-align: middle;
    word-break: break-all;
  `
)

const StyledCreatedText = styled.td(
  ({ theme }) => css`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 143%;
    color: ${theme.color.text.body.primary};

    margin-left: 54px;
  `
)

const StyledTimeExpired = styled.td<{ expired: boolean }>(
  ({ theme, expired }) => css`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 143%;
    color: ${expired ? theme.color.foreground.core.disabled : theme.color.text.body.primary};
  `
)

const StyledArrowWrapper = styled.td(
  () => css`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 143%;
    text-align: right;
  `
)
